var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"letter",class:{ 'guessed': _vm.guessed, 'flipped': _vm.flipped, 'missed': _vm.missed }},[_vm._v(_vm._s(_vm.displayValue))])}
var staticRenderFns = []

export { render, staticRenderFns }